<template lang="html">
  <div>
    <v-col cols="12">
      <div class="subtitle-2 font-weight-bold mb-2">
        {{ `${$tc('title.configuracao_acesso', 1)}:` }}
      </div>
      <v-divider class="mb-4"></v-divider>
    </v-col>

    <v-row class="ml-4 mb-3">
      <v-col cols="12" sm="6" md="3" class="pb-2">
        <label for="status-toggle" class="v-label theme--light caption grey--text text--darken-1 d-block mb-1">
          {{ `${$tc('label.status', 1)}*` }}
        </label>
        <v-btn-toggle
          id="status-toggle"
          v-model="usuario.indAtivo"
          mandatory
          dense
          class="custom-toggle"
          @change="changeIndAtivo"
        >
          <v-btn
            :value="true"
            :disabled="desabilitarBotaoAtivo"
            :class="usuario.indAtivo ? 'blue lighten-5 blue--text text--accent-4 font-weight-bold' : 'grey--text text--darken-2'"
          >
            {{ $t('label.ativo') }}
          </v-btn>
          <v-btn
            :value="false"
            :disabled="desabilitarBotaoInativo"
            :class="!usuario.indAtivo ? 'blue lighten-5 blue--text text--accent-4 font-weight-bold' : 'grey--text text--darken-2'"
          >
            {{ $t('label.inativo') }}
          </v-btn>
        </v-btn-toggle>
        <div
          v-if="exibirAlertaAprovacao"
          class="amber--text text--darken-3 caption mt-1 lh-tight"
        >
          {{ $t('message.necessario_solicitar_aprovacao_para_ativar') }}
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="3" class="pb-2">
        <label for="notificacao-email-toggle" class="v-label theme--light caption grey--text text--darken-1 d-block mb-1">
          {{ `${$tc('label.notificacao_email', 1)}*` }}
        </label>
        <v-btn-toggle
          id="notificacao-email-toggle"
          v-model="usuario.indRecebeMail"
          mandatory
          dense
          class="custom-toggle"
        >
          <v-btn
            :value="true"
            :disabled="somenteLeitura || desabilitarCadastroFornecedor"
            :class="usuario.indRecebeMail ? 'blue lighten-5 blue--text text--accent-4 font-weight-bold' : 'grey--text text--darken-2'"
          >
            {{ $t('label.inscrito') }}
          </v-btn>
          <v-btn
            :value="false"
            :disabled="somenteLeitura || desabilitarCadastroFornecedor"
            :class="!usuario.indRecebeMail ? 'blue lighten-5 blue--text text--accent-4 font-weight-bold' : 'grey--text text--darken-2'"
          >
            {{ $t('label.suspenso') }}
          </v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          id="usuario-perfil"
          class="custom-autocomplete"
          :disabled="somenteLeitura || desabilitarCadastroFornecedor"
          required
          :rules="[rules.required]"
          :no-data-text="$tc('message.nenhum_registro', 1)"
          :label="`${$tc('label.perfil', 1)} *`"
          v-model="usuario.idPerfil"
          :items="perfis"
          item-text="nomPerfil"
          item-value="id"
          clearable>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-text-field
          :label="$t('label.tipo_fornecedor')"
          v-model="usuario.tipoFornecedor"
          autocomplete="null"
          maxlength="100"
          counter
          :disabled="true">
        </v-text-field>
      </v-col>
    </v-row>

    <v-row class="ml-4 mb-3 align-end">
      <v-col cols="3" class="pb-2">
        <label for="vinculo-representacao-toggle" class="v-label theme--light caption grey--text text--darken-1 d-block mb-1">
          {{ `${$tc('label.vinculo_representacao', 1)}*` }}
        </label>
        <v-btn-toggle
          id="vinculo-representacao-toggle"
          v-model="usuario.indProcurador"
          mandatory
          dense
          class="custom-toggle"
          @change="handleProcuradorChange"
        >
          <v-btn
            :value="false"
            :disabled="somenteLeitura || desabilitarCadastroFornecedor"
          >
            {{ $t('label.contratual') }}
          </v-btn>
          <v-btn
            :value="true"
            :disabled="somenteLeitura || desabilitarCadastroFornecedor"
          >
            {{ $t('label.procuracao') }}
          </v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col cols="12" sm="6" md="4" v-if="exibirCamposDeVigencia">
        <v-menu
          v-model="menuInicio"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              :label="`${$tc('label.inicio_vigencia', 1)} * `"
              :rules="[rules.requiredVigencia, rules.validDate]"
              :disabled="somenteLeitura || !usuario.indProcurador || desabilitarCadastroFornecedor"
              v-model="dtaInicioVigenciaFormatada"
              :return-masked-value="true"
              v-mask="'##/##/####'"
              prepend-icon="event"
              hide-details="auto"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="pt-br"
            v-model="dtaInicioVigencia"
            @input="menuInicio = false; setarDataInicioNoUsuario()"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6" md="4" v-if="exibirCamposDeVigencia">
        <v-menu
          v-model="menuFim"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              :label="`${$tc('label.fim_vigencia', 1)} * `"
              :rules="regrasDataFim"
              :disabled="somenteLeitura || !usuario.indProcurador || desabilitarCadastroFornecedor"
              v-model="dtaFimVigenciaFormatada"
              :return-masked-value="true"
              v-mask="'##/##/####'"
              prepend-icon="event"
              hide-details="auto"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="pt-br"
            v-model="dtaFimVigencia"
            @input="menuFim = false; setarDataFimNoUsuario()"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <div class="mx-0 mb-3 align-end" v-if="!usuario.indProcurador">
        {{$tc('message.vigencia_total_representante_legal')}}
      </div>
    </v-row>

    <v-row class="ml-4 mb-3 align-center">

      <v-col cols="12" sm="4" md="4" class="pb-0">
        <v-autocomplete
          id="usuario-grupo-fornecedor"
          class="custom-autocomplete"
          v-model="filtroGrupoFornecedor"
          :disabled="somenteLeitura || desabilitarCadastroFornecedor"
          :label="`${$tc('label.grupo_fornecedor', 1)} *`"
          :items="gruposFornecedores"
          item-text="nome"
          item-value="id"
          clearable
          clear-on-select
          deletable-chips
          required
          hide-details="auto"
          @click:append="() => triggerSelecao('usuario-grupo-fornecedor')"
          @click.native="(i) => buscaAutocomplete(i, buscaGruposFornecedores)"
          :search-input.sync="triggerGrupoFornecedor">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="1" md="1" class="pb-0">
        <v-btn
          id="btn_incluir_linha"
          block
          depressed
          height="40"
          :disabled="somenteLeitura || desabilitarCadastroFornecedor"
          @click="incluirLinhaGrupoFornecedor(filtroGrupoFornecedor)"
          color="primary">
          {{ $t('label.adicionar') }}
        </v-btn>
      </v-col>

      <v-col v-if="$vuetify.breakpoint.smAndUp" cols="5" md="5" class="pb-0"></v-col>
    </v-row>
    <v-row class="ml-4 mb-3">
      <v-col cols="12" class="pa-0">
        <usuario-grupo-fornecedor-list
          :is-representante-legal="true"
          :lista-grupo-fornecedores="listaGrupoFornecedores"
          :desabilitar-cadastro-fornecedor="desabilitarCadastroFornecedor"
          :is-novo-cadastro="isNovoCadastro"
          :is-representacao-conjunto="usuario.indPossuiRepresentacaoConjunto"
          @abrirModalAnexos="abrirAnexos"
          @abrirModalRepresentacao="abrirRepresentacaoConjunto"
        >
        </usuario-grupo-fornecedor-list>
      </v-col>
    </v-row>

    <usuario-fornecedor-representacao-conjunto-dialog
      ref="modalRepresentacaoConjunto"
    />

    <usuario-fornecedor-documentacao-dialog
      ref="modalAnexos"
      :usuario="usuario"
      @documentacao-upload-success="atualizarQuantidadeArquivos"
    />
  </div>
</template>

<script>
import { triggerSelecao, buscaAutocomplete } from '@/common/functions/autocomplete-utils';
import UsuarioGrupoFornecedorList from '@/spa/usuario/UsuarioGrupoFornecedorList';
import {
  formatDateDDMMYYYYBarras,
  parseDateYYYYMMDDBarras,
} from '@/common/functions/date-utils';
import UsuarioFornecedorRepresentacaoConjuntoDialog from '@/spa/usuario/UsuarioFornecedorRepresentacaoConjuntoDialog';
import UsuarioFornecedorDocumentacaoDialog from '@/spa/usuario/UsuarioFornecedorDocumentacaoDialog';

export default {
  name: 'UsuarioFornecedorConfiguracoesAcessoRepresentanteLegal',
  props: {
    somenteLeitura: Boolean,
    usuario: {
      type: Object,
      default: () => ({}),
    },
    encontrouOmni: {
      type: Boolean,
      default: false,
    },
    isNovoCadastro: {
      type: Boolean,
      default: false,
    },
    desabilitarCadastroFornecedor: {
      type: Boolean,
      default: false,
    },
    tenantsUsuario: {
      type: Array,
      default: () => ([]),
    },
    perfis: {
      type: Array,
      default: () => ([]),
    },
    gruposFornecedores: {
      type: Array,
      default: () => ([]),
    },
    usuarioLogado: {
      type: Object,
      default: () => ({}),
    },
    indAtivoOriginal: {
      type: Boolean,
      default: false,
    },
    podeCadastrarAnexos: {
      type: Boolean,
      default: false,
    },
    podeVisualizarAnexos: {
      type: Boolean,
      default: false,
    },
    indFluxoAprovacaoRepreLegal: {
      type: Boolean,
      default: false,
    },
    existeFluxosImpactadosPorInativacao: {
      type: Boolean,
      default: false,
    },
    dadosFluxosAprovacaoImpactados: {
      type: Object,
      default: () => ({}),
    },
    permissaoSolicitarAprovacao: {
      type: Boolean,
      default: false,
    },
    isUsuarioAprovador: {
      type: Boolean,
      default: false,
    },
    indCancelandoEdicao: {
      type: Boolean,
      default: false,
    },
    isSolicitandoAprovacao: {
      type: Boolean,
      default: false,
    },
    podeCadastrarFornecedorRepresentanteLegal: {
      type: Boolean,
      default: false,
    },
    podeCadastrarFornecedorMaster: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UsuarioGrupoFornecedorList,
    UsuarioFornecedorRepresentacaoConjuntoDialog,
    UsuarioFornecedorDocumentacaoDialog,
  },
  data() {
    return {
      showHint: false,
      timeoutTrigger: null,
      triggerGrupoFornecedor: null,
      filtroGrupoFornecedor: null,
      listaGrupoFornecedores: [],
      menuInicio: false,
      menuFim: false,
      dtaInicioVigencia: null,
      dtaFimVigencia: null,
      dtaInicioVigenciaOriginal: '',
      dtaFimVigenciaOriginal: '',
      flagProcurador: false,
      quantidadeAnexosPorGrupo: {},
      grupoAnexosAtivo: null,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredVigencia: (value) => (!!value && !!value.trim()) || this.$t('message.campo_obrigatorio'),
        validDate: (value) => (!value || (value.length === 10 && this.moment(value, 'DD/MM/YYYY').isValid())) || this.$t('message.data_invalida'),
        dataFimMaiorInicio: () => this.isDataFimMaiorInicio() || this.$t('message.data_inicial_maior_final'),
        dataFimVencida: () => this.isDataNaoVencida() || this.$t('message.data_final_menor_data_atual'),
        dataFimExpiraTrintaDias: () => this.isDataNaoVencidaEmTrintaDias() || this.$t('message.data_final_vence_trinta_dias'),
      },
    };
  },
  computed: {
    exibirCamposDeVigencia() {
      this.flagProcurador = !!this.usuario.indProcurador;
      const isUsuarioMasterEProcurador = this.habilitaCampoDataSemIndProcurador || this.flagProcurador;
      return isUsuarioMasterEProcurador;
    },
    habilitaCampoDataSemIndProcurador() {
      return !this.usuario.indProcurador && !this.isNovoCadastro
       && ((this.usuario.statusFluxo && this.usuario.statusFluxo === 'APROVADO') || !this.usuario.statusFluxo)
       && this.usuario.dtaInicioVigencia && this.usuario.dtaFimVigencia;
    },
    desabilitarFlagAtivo() {
      return this.somenteLeitura || this.desabilitarCadastroFornecedor
        || (!this.isNovoCadastro && ['AGUARDANDO_APROVACAO'].includes(this.usuario.statusFluxo) && !this.usuario.indAtivo);
    },
    desabilitarBotaoAtivo() {
      return this.somenteLeitura
        || this.desabilitarCadastroFornecedor
        || (!this.isUsuarioAprovador && !this.indAtivoOriginal);
    },
    desabilitarBotaoInativo() {
      return this.somenteLeitura || this.desabilitarCadastroFornecedor;
    },
    exibirAlertaAprovacao() {
      return this.permissaoSolicitarAprovacao
        && !this.isUsuarioAprovador
        && !this.indAtivoOriginal
        && !this.usuario.indAtivo
        && this.usuario.statusFluxo !== 'AGUARDANDO_APROVACAO';
    },
    isDtaFinalMenorQueDtaAtual() {
      return this.usuario.indProcurador
        && !this.isDataNaoVencida()
        && this.usuario.indAtivo
        && this.isUsuarioAprovador;
    },
    regrasDataFim() {
      const baseRules = [
        this.rules.requiredVigencia,
        this.rules.validDate,
        this.rules.dataFimMaiorInicio,
        this.rules.dataFimExpiraTrintaDias,
      ];
      const deveIgnorarRegraVencida = (!this.isNovoCadastro
        && !this.indAtivoOriginal
        && !this.usuario.indProcurador
        && !this.isDataNaoVencida());
      if (!deveIgnorarRegraVencida) {
        baseRules.push(this.rules.dataFimVencida);
      }
      return baseRules;
    },
    dtaInicioVigenciaFormatada: {
      get() {
        if (this.dtaInicioVigencia) {
          return formatDateDDMMYYYYBarras(this.dtaInicioVigencia);
        }
        return this.usuario.dtaInicioVigencia ? formatDateDDMMYYYYBarras(this.usuario.dtaInicioVigencia) : null;
      },
      set(newValue) {
        const parsed = newValue ? parseDateYYYYMMDDBarras(newValue) : null;
        this.dtaInicioVigencia = parsed;
        this.usuario.dtaInicioVigencia = parsed;
      },
    },
    dtaFimVigenciaFormatada: {
      get() {
        if (this.dtaFimVigencia) {
          return formatDateDDMMYYYYBarras(this.dtaFimVigencia);
        }
        return this.usuario.dtaFimVigencia ? formatDateDDMMYYYYBarras(this.usuario.dtaFimVigencia) : null;
      },
      set(newValue) {
        const parsed = newValue ? parseDateYYYYMMDDBarras(newValue) : null;
        this.dtaFimVigencia = parsed;
        this.usuario.dtaFimVigencia = parsed;
      },
    },
  },
  watch: {
    triggerGrupoFornecedor(val) {
      if (this.filtroGrupoFornecedor) {
        const grupoSelecionado = this.gruposFornecedores
          .find((grupo) => grupo.id === this.filtroGrupoFornecedor);

        if (grupoSelecionado && grupoSelecionado.nome === val) {
          return;
        }
      }

      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }

      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) this.buscaGruposFornecedores(val);
      }, 500);
    },
    'usuario.dtaInicioVigencia': {
      handler(val) {
        if (val && !this.dtaInicioVigenciaOriginal) {
          this.dtaInicioVigenciaOriginal = val;
        }
      },
      immediate: true,
    },
    'usuario.dtaFimVigencia': {
      handler(val) {
        if (val && !this.dtaFimVigenciaOriginal) {
          this.dtaFimVigenciaOriginal = val;
        }
      },
      immediate: true,
    },
  },
  methods: {
    buscaAutocomplete,
    triggerSelecao,
    handleProcuradorChange() {
      this.flagProcurador = !!this.usuario.indProcurador;
      if (!this.usuario.indProcurador) {
        this.usuario.dtaInicioVigencia = null;
        this.usuario.dtaFimVigencia = null;
        this.dtaInicioVigencia = null;
        this.dtaFimVigencia = null;
      }
      this.$forceUpdate();
    },
    incluirLinhaGrupoFornecedor(idGrupo) {
      if (!idGrupo) return;

      let idsFornecedorLogado = [];
      if (this.usuarioLogado) {
        idsFornecedorLogado = this.usuarioLogado.idsGrupoFornecedor || [];
      }
      const jaExiste = this.listaGrupoFornecedores.some((g) => g.id === idGrupo);
      if (jaExiste) {
        this.$toast(this.$t('message.registro_ja_adicionado'));
        return;
      }

      const grupoEncontrado = this.gruposFornecedores.find((g) => g.id === idGrupo);
      let pertenceAoGrupoDoUsuarioLogado = true;
      if (grupoEncontrado) {
        pertenceAoGrupoDoUsuarioLogado = this.usuarioLogado.tipo === 'FUNCIONARIO'
          ? true
          : idsFornecedorLogado.includes(grupoEncontrado.id);

        const grupoAdd = {
          ...grupoEncontrado,
          desabilitaDeletar: !pertenceAoGrupoDoUsuarioLogado,
          nomesCnpjsFormatados: grupoEncontrado.nomesCnpjs
            .map((item) => item.nome_cnpj)
            .join('\n'),
        };

        this.listaGrupoFornecedores.push(grupoAdd);
        this.filtroGrupoFornecedor = null;
      }
    },
    removerLinhaGrupoFornecedor(item) {
      const index = this.listaGrupoFornecedores.indexOf(item);
      if (index > -1) {
        this.listaGrupoFornecedores.splice(index, 1);
      }
    },
    buscaGruposFornecedores(autocomplete) {
      this.$emit('BuscarGruposFornecedores', null, autocomplete);
    },
    abrirRepresentacaoConjunto(grupo) {
      this.$refs.modalRepresentacaoConjunto.open(grupo);
    },
    abrirAnexos(grupo) {
      this.grupoAnexosAtivo = grupo;
      this.$refs.modalAnexos.open(grupo, this.usuario.dtaInicioVigencia, this.usuario.dtaFimVigencia);
    },
    atualizarQuantidadeArquivos(quantidade) {
      if (!this.grupoAnexosAtivo || !this.grupoAnexosAtivo.id) return;
      this.$set(this.quantidadeAnexosPorGrupo, this.grupoAnexosAtivo.id, quantidade);
    },
    isDataFimMaiorInicio() {
      const dtInicio = this.moment(this.dtaInicioVigenciaFormatada, 'DD/MM/YYYY');
      const dtFinal = this.moment(this.dtaFimVigenciaFormatada, 'DD/MM/YYYY');
      return dtFinal.isAfter(dtInicio);
    },
    isDataNaoVencida() {
      if (this.usuario.dtaFimVigencia) {
        const hoje = this.moment();
        const dtFinal = this.moment(this.usuario.dtaFimVigencia, 'YYYY-MM-DD');
        return dtFinal.isSameOrAfter(hoje);
      }
      return false;
    },
    isDataNaoVencidaEmTrintaDias() {
      // Regra ativa apenas quando a data foi alterada ou está em fluxo de aprovação
      if (this.usuario.dtaFimVigencia && (this.isDataFimVigenciaAlterada() || this.isSolicitandoAprovacao)) {
        const vigenciaTrintaDias = this.moment().add(30, 'days');
        const dtFinal = this.moment(this.usuario.dtaFimVigencia, 'YYYY-MM-DD');
        return dtFinal.isAfter(vigenciaTrintaDias);
      }
      return true;
    },
    isDataFimVigenciaAlterada() {
      return !!(this.usuario.dtaFimVigencia
        && this.dtaFimVigenciaOriginal
        && this.dtaFimVigenciaOriginal !== this.usuario.dtaFimVigencia);
    },
    changeIndAtivo() {
      if (this.somenteLeitura || this.indCancelandoEdicao) return;

      if (!this.isNovoCadastro && this.indAtivoOriginal && !this.usuario.indAtivo
          && this.existeFluxosImpactadosPorInativacao) {
        this.$emit('abrir-modal-fluxos-impactados', {
          idUsuario: this.usuario.id,
          nomeFornecedor: this.usuario.nomeSobrenome,
          dadosFluxosAprovacaoImpactados: this.dadosFluxosAprovacaoImpactados,
          indReprovacaoUsuarioFornecedorMaster: false,
          indMudouTipoUsuario: false,
        });
        return;
      }

      if (this.isDtaFinalMenorQueDtaAtual && this.usuario.indAtivo) {
        this.usuario.indAtivo = false;
        this.$toast(this.$t('errors.data.final_menor_data_atual'));
        return;
      }

      if (this.indFluxoAprovacaoRepreLegal && this.permissaoSolicitarAprovacao && this.usuario.indAtivo
          && !this.isUsuarioAprovador && !this.indAtivoOriginal) {
        this.usuario.indAtivo = false;
        this.$emit('confirmar-ativacao-inativo');
        return;
      }

      this.$emit('status-alterado', this.usuario.indAtivo);
    },
    setarDataInicioNoUsuario() {
      this.usuario.dtaInicioVigencia = this.dtaInicioVigencia;
      if (!this.usuario.dtaFimVigencia) {
        this.usuario.dtaFimVigencia = this.usuario.dtaFimVigenciaPrevia;
        this.dtaFimVigencia = this.usuario.dtaFimVigenciaPrevia;
      }
    },
    setarDataFimNoUsuario() {
      this.usuario.dtaFimVigencia = this.dtaFimVigencia;
      if (!this.usuario.dtaInicioVigencia) {
        this.usuario.dtaInicioVigencia = this.usuario.dtaInicioVigenciaPrevia;
        this.dtaInicioVigencia = this.usuario.dtaInicioVigenciaPrevia;
      }
    },
    restaurarDatasLocais() {
      this.dtaInicioVigencia = this.usuario.dtaInicioVigencia;
      this.dtaFimVigencia = this.usuario.dtaFimVigencia;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.row {
  margin-left: 0;
  margin-right: 0;
}

.hint-laranja .v-messages__message:not(.error--text) {
  color: orange !important;
}

.hint-laranja ::v-deep .v-messages__message:not(.error--text) {
  color: orange !important;
}

.custom-toggle {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.custom-toggle .v-btn {
  border-radius: 8px !important;
  border: none !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  height: 36px !important;
  min-width: 80px !important;
  box-shadow: none !important;
}

.custom-toggle .v-btn:not(:last-child) {
  margin-right: 8px !important;
}

.lh-tight {
  line-height: 1.2;
  font-size: 0.85rem !important;
}

.custom-toggle {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.custom-toggle .v-btn {
  background-color: #f5f5f5 !important;
  color: #757575 !important;
  border-radius: 8px !important;
  border: none !important;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 0.5px;
  height: 36px !important;
  min-width: 80px !important;
  box-shadow: none !important;
}

.custom-toggle .v-btn:not(:last-child) {
  margin-right: 8px !important;
}

.custom-toggle .v-btn.v-btn--active {
  background-color: #caddff !important;
  color: #2864f0 !important;
}

.custom-toggle .v-btn.v-btn--active::before {
  opacity: 0 !important;
}
</style>
